import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  useGetMemberDelegationTask,
  useUpdateMemberDelegationTask,
} from "services/delegation";
import { DelegationTask } from "protogen/delegations_pb";
import { UploadAttachment } from "protogen/common_pb";
import { PlainMessage } from "@bufbuild/protobuf";
import SubtaskDetail from "components/delegation/SubtaskDetail";
import { Family } from "protogen/advisors_service_pb";

export default () => {
  const { ref } = useParams<{ ref: string }>();
  const [task, setTask] = useState<DelegationTask | null>(null);
  const [familyInfo, setFamilyInfo] = useState<Family | null>(null);

  const { request: getTask, loading } = useGetMemberDelegationTask(
    (response) => {
      if (response.delegationTask) {
        setTask(response.delegationTask);
      }
      if (response.familyInfo) {
        setFamilyInfo(response.familyInfo);
      }
    },
  );

  const { request: updateTask, loading: updating } =
    useUpdateMemberDelegationTask((response) => {
      if (response.delegationTask) {
        setTask(response.delegationTask);
      }
    });

  useEffect(() => {
    if (ref) {
      getTask({ ref });
    }
  }, [ref]);

  const handleStatusChange = async (
    status: string,
    comment?: string,
    _unassign?: boolean,
    attachments?: PlainMessage<UploadAttachment>[],
    _actionDateSec?: number,
    recipientType?: string,
    commentHtml?: string,
  ) => {
    if (!task) return;
    await updateTask({
      ref: task.ref,
      status,
      commentContent: comment || "",
      commentContentHtml: commentHtml || "",
      attachments: attachments || [],
      recipientType: recipientType || "",
    });
  };

  const handleAddComment = async (
    content: string,
    attachments?: PlainMessage<UploadAttachment>[],
    recipientType?: string,
    contentHtml?: string,
  ) => {
    if (!task) return;
    await updateTask({
      ref: task.ref,
      status: "",
      commentContent: content,
      commentContentHtml: contentHtml || "",
      attachments: attachments || [],
      recipientType: recipientType || "",
    });
  };

  const handleRefresh = () => {
    if (ref) {
      getTask({ ref });
    }
  };

  return (
    <SubtaskDetail
      task={task}
      familyInfo={familyInfo}
      loading={loading}
      updating={updating}
      accountType="member"
      onStatusChange={handleStatusChange}
      onAddComment={handleAddComment}
      onSaveTimeEntries={async () => {}}
      onRefresh={handleRefresh}
      backPath="/delegations"
      breadcrumbs={[
        { name: "Home", link: "/home" },
        { name: "Helping hands", link: "/delegations" },
      ]}
    />
  );
};
